import * as API from '@/services/API';

export default {
  addContact({ commit, dispatch }, payload) {
    return API.apiClient
      .post('/contacts', payload)
      .then((response) => {
        dispatch('list');
        dispatch('view', response.data.id);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  delete({ commit, dispatch }, id) {
    return API.apiClient
      .delete('/contacts/' + id)
      .then((response) => {
        commit('SET_CURRENT_CONTACT', null);
        dispatch('list');
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  async view({ commit }, contactId) {
    await API.apiClient
      .get('/contacts/' + contactId)
      .then((response) => {
        commit('SET_CURRENT_CONTACT', response.data);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  async list({ commit }, filter) {
    return await API.apiClient
      .get('/contacts' + (filter ? '?query=last_name:' + filter + '*' : ''))
      .then((response) => {
        commit('SET_LIST', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  async paginate({ commit }, url) {
    return await API.apiClient
      .get(url)
      .then((response) => {
        commit('SET_LIST', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  updateContact({ commit, dispatch }, payload) {
    return API.apiClient
      .put('/contacts/' + payload.id, payload)
      .then((response) => {
        dispatch('list');
        dispatch('view', payload.id);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  search({ commit }, searchString) {
    return API.apiClient
      .get('/contacts/search?query=' + searchString)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  //get related listings
  async getListings({ commit }, contactId) {
    return await API.apiClient
      .get('/contacts/' + contactId + '/properties')
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  //get related opportunities
  async getOpportunities({ commit }, contactId) {
    return await API.apiClient
      .get('/contacts/' + contactId + '/opportunities')
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
};
